module.exports = __webpack_public_path__ + "img/Divine.7cfd3c1a.jpg";